import { render, staticRenderFns } from "./ContentPage.vue?vue&type=template&id=4e91e636&"
import script from "./ContentPage.vue?vue&type=script&lang=js&"
export * from "./ContentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SliderHeros: require('/vercel/path0/components/heros/SliderHeros.vue').default,NoSliderHero: require('/vercel/path0/components/heros/NoSliderHero.vue').default,ComponentLoader: require('/vercel/path0/components/general/ComponentLoader.vue').default})
